import { useState } from 'react'
import MultiFrameworkAssessor from './components/MultiFrameworkAssessor'
import SkillsBrowser from './components/SkillsBrowser'

const TOOLS = [
  {
    id: 'assessor',
    name: 'Multi-Framework Assessor',
    desc: 'NIST CSF 2.0 · CMMC 2.0 Level 2 · CJIS v6.0',
    badge: 'ASSESS',
    color: '#0ea5e9',
  },
  {
    id: 'skills',
    name: 'GRC Skills Browser',
    desc: '759 cybersecurity skills · 5 CyberEye custom GRC skills',
    badge: 'SKILLS',
    color: '#8b5cf6',
  },
]

export default function App() {
  const [active, setActive] = useState(null)

  if (active === 'assessor') return <MultiFrameworkAssessor />
  if (active === 'skills') return <SkillsBrowser />

  return (
    <div style={{
      minHeight: '100vh',
      background: '#060b14',
      fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      position: 'relative',
    }}>
      <div style={{
        position: 'fixed', inset: 0,
        background: 'radial-gradient(ellipse 80% 50% at 20% -10%, rgba(14,165,233,0.07) 0%, transparent 60%), radial-gradient(ellipse 60% 40% at 80% 110%, rgba(99,102,241,0.06) 0%, transparent 60%)',
        pointerEvents: 'none',
      }} />

      <div style={{ textAlign: 'center', marginBottom: 40, position: 'relative', zIndex: 1 }}>
        <svg width="44" height="44" viewBox="0 0 28 28" style={{ marginBottom: 12 }}>
          <polygon points="14,2 26,8 26,20 14,26 2,20 2,8" fill="none" stroke="#0ea5e9" strokeWidth="1.5"/>
          <polygon points="14,7 22,11 22,17 14,21 6,17 6,11" fill="none" stroke="#0ea5e9" strokeWidth="0.8" opacity="0.4"/>
          <circle cx="14" cy="14" r="3" fill="#0ea5e9"/>
        </svg>
        <div style={{ fontSize: 11, color: '#0ea5e9', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: 8 }}>
          CyberEye Solutions
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: '#f1f5f9', margin: '0 0 8px', lineHeight: 1.2 }}>
          GRC Tools Platform
        </h1>
        <p style={{ fontSize: 13, color: '#64748b', margin: 0 }}>
          AI-powered governance, risk &amp; compliance for modern security teams
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, maxWidth: 600, width: '100%', position: 'relative', zIndex: 1 }}>
        {TOOLS.map(tool => (
          <button
            key={tool.id}
            onClick={() => setActive(tool.id)}
            style={{
              background: 'rgba(255,255,255,0.03)',
              border: `1px solid rgba(255,255,255,0.08)`,
              borderTop: `2px solid ${tool.color}`,
              borderRadius: 12,
              padding: '24px 20px',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 0.15s',
              color: '#e2e8f0',
            }}
          >
            <div style={{
              fontSize: 10, fontWeight: 800,
              padding: '2px 8px', borderRadius: 4,
              background: tool.color + '20', color: tool.color,
              border: `1px solid ${tool.color}40`,
              display: 'inline-block', marginBottom: 12,
              letterSpacing: '0.08em',
            }}>
              {tool.badge}
            </div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#f1f5f9', marginBottom: 6 }}>
              {tool.name}
            </div>
            <div style={{ fontSize: 11, color: '#64748b', lineHeight: 1.5 }}>
              {tool.desc}
            </div>
            <div style={{ fontSize: 11, color: tool.color, marginTop: 14, fontWeight: 700 }}>
              Launch →
            </div>
          </button>
        ))}
      </div>

      <div style={{ marginTop: 40, fontSize: 10, color: '#1e293b', position: 'relative', zIndex: 1 }}>
        Powered by Anthropic Claude · CyberEye Solutions GRC Practice
      </div>
    </div>
  )
}
